import i18n from '../i18n';

// Announcement labels are translated through the i18n instance directly
// because these helpers are called during render, where the surrounding
// useTranslation()/withTranslation() context re-renders on language change.
export const announcementStatusString = (status) => {
    switch (status) {
        case 'draft':
            return i18n.t('announcements.statusDraft');
        case 'scheduled':
            return i18n.t('announcements.statusScheduled');
        case 'published':
            return i18n.t('announcements.statusPublished');
        case 'archived':
            return i18n.t('announcements.statusArchived');
        case 'template':
            return i18n.t('announcements.statusTemplate');
        default:
            return '-';
    }
};

export const announcementTypeString = (type) => {
    switch (type) {
        case 'club':
            return i18n.t('announcements.typeClub');
        case 'weekly':
            return i18n.t('announcements.typeWeekly');
        case 'general':
            return i18n.t('announcements.typeGeneral');
        case 'event':
            return i18n.t('announcements.typeEvent');
        default:
            return type;
    }
};

export const platformString = (platform) => {
    switch (platform) {
        case 'website':
            return i18n.t('announcements.platformWebsite');
        case 'app':
            return i18n.t('announcements.platformApp');
        case 'emailAll':
            return i18n.t('announcements.platformEmailAll');
        case 'emailFreshers':
            return i18n.t('announcements.platformEmailFreshers');
        case 'discord':
            return i18n.t('announcements.platformDiscord');
        case 'telegram':
            return i18n.t('announcements.platformTelegram');
        case 'linkedin':
            return i18n.t('announcements.platformLinkedIn');
        default:
            return platform;
    }
};
